import { useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';
import i18n from '@/utils/i18n';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/** Icon-only copy-to-clipboard button for an integration token. */
export const CopyTokenButton = ({ token }: { token: string | undefined }) => {
  const [copied, setCopied] = useState(false);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          disabled={!token}
          onClick={() => {
            if (!token) {
              return;
            }
            navigator.clipboard.writeText(token);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          }}
        >
          {copied ? (
            <CheckIcon className="tw:size-4" />
          ) : (
            <CopyIcon className="tw:size-4" />
          )}
          <span className="tw:sr-only">{i18n.t('Integrations:copyToken')}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {copied
          ? i18n.t('Integrations:copied')
          : i18n.t('Integrations:copyToken')}
      </TooltipContent>
    </Tooltip>
  );
};
